import { Task } from '@/types';

export enum RecoveryStage {
    IDLE = 'IDLE',
    DETECTION = 'DETECTION',
    TRIAGE = 'TRIAGE',
    ACTIVE = 'ACTIVE',
    COMPLETED = 'COMPLETED'
}

export interface RecoveryPlan {
    id: string;
    userId: string;
    createdAt: string;
    originalTaskCount: number;
    tasks: RecoveryTask[];
    currentStepIndex: number;
    status: 'active' | 'completed' | 'abandoned';
}

export interface RecoveryTask extends Task {
    recoveryAction: 'focus' | 'delegate' | 'simplify' | 'break';
    originalDueDate: string;
    recommendedDuration: number; // in minutes
    isLocked: boolean; // True if it cannot be started yet (linear flow)
}

export interface OverwhelmStatus {
    isOverwhelmed: boolean;
    score: number; // 0-100, where 100 is maximum panic
    reason: string[]; // e.g., ["3 overdue tasks", "2 deadlines in 24h"]
    overdueTasks: Task[];
    upcomingCriticalTasks: Task[];
}

export interface CurriculumIngestionResult {
    parsedTasks: Task[];
    semesterTimeline: {
        start: string;
        end: string;
    };
}
